export const EmptyState = () => (
  <div className="flex min-h-[300px] flex-col items-center justify-center px-4 py-12">
    <img
      src="/suggested-providers.png"
      alt="No records to show"
      className="mb-4 max-w-[200px]"
    />
    <h3 className="text-lg font-semibold">No records to show</h3>
    <p className="text-muted-foreground text-sm">
      Processed medication data will appear here.
    </p>
  </div>
);
